module.exports = __webpack_public_path__ + "static/media/medlink-logo@3x.d297b0eb.png";